import { io } from "socket.io-client"

// URL do servidor WhatsApp API local
//const API_URL = 'http://ftptrade.ddns.net:3070';
// URL do servidor WhatsApp API na hostinger
const API_URL = 'https://crm-api.tradesystem.cloud';

const socket = io(API_URL);

socket.on('connect', () => {
    console.log('Conectado no socket');
})

socket.on('disconnect', () => {
    console.log('Desconectado do socket');
})

export { API_URL };
export default socket;
